(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("quill"));
	else if(typeof define === 'function' && define.amd)
		define(["quill"], factory);
	else if(typeof exports === 'object')
		exports["quillTable"] = factory(require("quill"));
	else
		root["quillTable"] = factory(root["quill"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition